/* @flow */

import {
  getEventCustomId,
  getEventPlatformURL,
} from '@e180/domain/lib/event/util';
import { assertObject } from '@e180/util/lib/assert';

import type { State } from 'src/shared/core/type/reduxTypes';

import { getPlatformBaseDomain } from 'src/shared/app/base/selector/appEnvSelectors';
import { getEventSafely } from 'src/shared/domain/event/selector/eventSelectors';

export const rootPath = '/';

export const errorReportingPublicKey = '288eabca750f4e138aed7d6a9fa65db9';
export const errorReportingProjectId = '14';
export const errorReportingWhiteUrls = [/^(.*)\.braindate\.com$/];

export const iconBgColor = '#93ccc0';

export const privacyUrl =
  'https://api-media.braindate.com/misc/Privacy+policy-en.pdf';
export const termsUrl =
  'https://api-media.braindate.com/misc/Terms+of+service-en.pdf';
export const privacyUrlFrench =
  'https://api-media.braindate.com/misc/Privacy+policy-fr.pdf';
export const termsUrlFrench =
  'https://api-media.braindate.com/misc/Terms+of+service-fr.pdf';

export const defaultPlatformUrl = 'https://braindate.com';

// CSP related urls
export const cspLocalhostSrc = 'http://localhost:8080 ws://localhost:8080';
export const cspFontSrc = 'https://fonts.gstatic.com/';
export const cspFrameSrc = 'https://www.youtube.com';
export const cspGoogleFontSrc = 'http://fonts.googleapis.com/css';

/**
 * Get the platform URL. If found in the event key of the state, returns that URL.
 * If not, build the URL from the customID of the event and the environment variable
 * for the platform.
 * @param   {State} state - Redux state
 * @returns {string} - The Platform absolute URL
 *
 * @throws Will throw an exception if parameters are not valid
 */
export function getPlatformURL(state: State): string {
  assertObject(state, 'state');

  const event = getEventSafely(state);

  return (
    getEventPlatformURL(event) ||
    `https://${getEventCustomId(event)}${getPlatformBaseDomain(state)}/`
  );
}
